import React, { useState, useEffect } from 'react';
import binanceIcon from '../images/buttons/binance_square_icon.png';
import { Input } from "./Input";

const WalletConnectModal = ({ isOpen, onClose, onConnectWallet, onSubmitAddress, initialAddress = '' }) => {
  const [bscAddress, setBscAddress] = useState(initialAddress);
  const [error, setError] = useState('');
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
    } else {
      setTimeout(() => {
        setIsVisible(false);
      }, 300);
    }
  }, [isOpen]);

  useEffect(() => {
    if (initialAddress) {
      setBscAddress(initialAddress);
    }
  }, [initialAddress]);

  const handleSubmit = () => {
    // Simple validation for BSC address (should start with 0x and be 42 chars long)
    if (!bscAddress) {
      setError('Please enter the BSC address');
      return;
    }
    
    if (!bscAddress.startsWith('0x') || bscAddress.length !== 42) {
      setError('Please enter a valid BSC address');
      return;
    }
    
    setError('');
    onSubmitAddress(bscAddress);
  };

  const handleInputChange = (e) => {
    setBscAddress(e.target.value);
    if (error) setError('');
  };

  const handleConnectWalletClick = () => {
    onConnectWallet();
  };

  if (!isVisible && !isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 w-full h-full">
      {/* Backdrop with semi-transparent dark background */}
      <div 
        className={`fixed w-full h-full top-0 left-0 bg-[#1c1f25b2] transition-opacity duration-300 ${isOpen ? 'opacity-100' : 'opacity-0'}`} 
        onClick={onClose}
      />
      
      {/* Modal from bottom half of screen */}
      <div 
        className={`fixed w-full max-h-[450px] bottom-0 left-0 bg-white rounded-t-[20px] transition-transform duration-300 ${isOpen ? 'translate-y-0' : 'translate-y-full'}`}
      >
        <div className="flex flex-col w-full h-full items-center p-5">
          <div className="flex flex-col w-full max-w-[335px] items-center">
            {/* Title */}
            <div className="relative self-stretch mt-[-1.00px] font-medium text-[#1C1F25] text-2xl text-center tracking-[0] leading-[normal] mb-6">
              Connect Wallet
            </div>
            
            {/* BSC Wallet Connect Button */}
            <button 
              onClick={handleConnectWalletClick}
              className="flex w-full items-center justify-center gap-2.5 px-5 py-[16px] rounded-[12px] bg-[#F0B90B] mb-4"
            >
            <div className="w-5 h-5 rounded-full overflow-hidden">
              <img src={binanceIcon} alt="Binance" className="w-full h-full object-cover" />
            </div>
              <div className="relative w-fit font-medium text-black text-base tracking-[0] leading-[normal] whitespace-nowrap">
                Connect BSC Wallet
              </div>
            </button>

            {/* Divider */}
            <div className="w-full h-[1px] bg-[#E5E7EB] my-4"></div>

            {/* Enter BSC Address Section */}
            <div className="relative self-stretch font-medium text-[#1C1F25] text-2xl text-center tracking-[0] leading-[normal] mb-6">
              Enter BSC Address
            </div>
            
            {/* Custom Input component */}
            <div className="w-full mb-4">
              <Input
                className="w-full"
                inputClassName="bg-white"
                state="filled"
                text="Wallet address"
                text1="0x..."
                value={bscAddress}
                onChange={handleInputChange}
              />
              {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
            </div>
            
            {/* Submit Button with gradient background */}
            <button 
              onClick={handleSubmit}
              className="flex w-full items-center justify-center gap-2.5 px-2.5 py-[13px] rounded-[12px] overflow-hidden shadow-[0px_2px_3px_0px_rgba(204,205,207,0.15)] [background:linear-gradient(94deg,#70EB7A_0.85%,#5FD9C8_0.86%,#70A8EB_49.9%,#74A6EC_62.57%,#B38EFF_88.43%,#E356C5_118.49%,#F9AD58_138.8%)]"
            >
              <div className="relative w-fit mt-[-1.00px] font-medium text-white text-base tracking-[0] leading-[normal] whitespace-nowrap">
                Submit
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WalletConnectModal; 